import classNames from "classnames";
import {Product} from "@/entities/product";
import {CatalogCard} from "@/widgets/catalog-card";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import {useProductRelatedCarousel} from "../model/hooks/useProductRelatedCarousel";
import {Svg} from "@/shared/ui/Svg";
import styles from "./ProductRelated.module.scss";

type Props = {
    products: Product[];
}

export const ProductRelated = ({products}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useProductRelatedCarousel();

    const {registerView} = useViewItemBatcher();

    if (products.length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={`globalContainer`}><p className={styles.title}>Покупают вместе</p></div>
            <div className={styles.carousel}>
                <div className={`globalContainer`}>
                    <div ref={carouselRef} className={styles.carouselViewport}>
                        <div className={styles.carouselContainer}>
                            {products.map((product, i) => {
                                return (
                                    <CatalogCard
                                        key={product.id}
                                        product={product}
                                        className={styles.carouselSlide}
                                        index={i + 1}
                                        registerView={registerView}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
                {products.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
